import type { FaireProductEntity } from "../../entity_types/product";

export const p_ga9qg8b625: FaireProductEntity = {
  token: "p_ga9qg8b625",
  type: "product",
  name: "925 Silver Moissanite Diamond Stackable Eternity Band Ring",
  brandToken: "b_uq6uf6uvrw",
  brandName: "Jay Jools",
  imageUrl:
    "https://cdn.faire.com/fastly/27549bd568c64ab00a65f207b304d039ba739e3c0132b018a05fbc03a6267fef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3cae72c16711dcb7e0b5242c83a57710827c31c54b951fccae4d866280a4975.jpeg",
    "https://cdn.faire.com/fastly/d4cd16d331b14352bcbdd63ffbcbf1e21da2bec019e1127f210b835640b7ec2b.jpeg",
    "https://cdn.faire.com/fastly/2932fea0c769eb396f27423494f11fa220e768894388e3f3729a35ee634ab5d4.jpeg",
    "https://cdn.faire.com/fastly/45eb179d3e87bc9d65038688cf66bcdb1411881fc9e51852d746b8d6be0308ed.jpeg",
    "https://cdn.faire.com/fastly/a81a1f58a5412d68f5873cef7f5f62c1b44d7461664c3a8d9c82cabe62799d62.jpeg",
    "https://cdn.faire.com/fastly/0de7e58eff8ae4d1be153b348ab0546da18cd16c3f93512241d7cbd8ba8b87c6.jpeg",
    "https://cdn.faire.com/fastly/296a8b7c91978b0e33b5e4ebbba0c0826c10014a6c90481b51456a9cd79d5a5e.jpeg",
    "https://cdn.faire.com/fastly/bc65d12a34df9dd1fa9661ce29bd1c853fec0b267bc73451d449ad31302d1bd2.jpeg",
    "https://cdn.faire.com/fastly/d3b80877f68de57b0d276196a731f043f916e1a8d8b56e660454e5ef9103df83.jpeg",
    "https://cdn.faire.com/fastly/1eff0b9621d870a654b758b18e1108e866560ce09ecaf14597172b41195d31fd.jpeg",
    "https://cdn.faire.com/fastly/bc6f24660c54730deee66996cc7d5cb29b10fb1c506260cefb0feed305e9e107.jpeg",
    "https://cdn.faire.com/fastly/b477592e969e23874233b4835f5ec6c4aa45c90d61954f61b3bac82810e9a262.jpeg",
  ],
  priceDollars: 52.64,
  description:
    "Crafted in premium 925 sterling silver, this elegant Moissanite Diamond eternity band features a row of brilliant stones that sparkle with every movement. Designed for a sleek, minimalist look, it’s perfect for stacking or wearing alone as a wedding, promise, or everyday ring. Durable, lightweight, and comfortable for daily wear, this timeless piece offers the beauty of fine jewelry at an affordable price—a perfect gift for anniversaries, special occasions, or someone you love.\n\nProduct Details\n\nGemstone: Moissanite Diamond (SR1720)\nMetal: 925 Sterling Silver\nStyle: Ring\nPackaging: Gift-ready box included\n\nWhy Choose JAY JOOLS\n\nHandcrafted in our in-house studio\nMade with 100% genuine, natural gemstones\nHallmarked 925, with 92.5%+ pure silver guaranteed\nSuperior 1-micron plating for lasting quality\nAvailable in Silver, Gold, and Rose Gold—plated over solid 925 Sterling Silver.\n\nNote: As each stone is natural, slight variations in texture and color are expected, ensuring that every piece is unique. Stone quality will always match what’s shown.",
  tags: [],
  msrpDollars: 105.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:25.439Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
